module.exports = __webpack_public_path__ + "img/interaction-step-welcome.d2d72e59.jpg";